import React, { useState, useEffect } from 'react';


const quests = [
    { id: 1, question: "Write a PHP program to perform arithmetic operations." },
    { id: 2, question: "Explain different types of arrays in PHP with an example." },
    { id: 3, question: "Write a program to perform CRUD operations using PHP." },
    { id: 4, question: "Write a PHP program to display Even or odd number." },
    { id: 5, question: "Write a PHP program to display Prime number." },
    { id: 6, question: "Write a PHP program to display Table of number." },
    { id: 7, question: "Write a PHP program to display Factorial." },
    { id: 8, question: "Write a PHP program to display Armstrong number." },
    { id: 9, question: "Write a PHP program to display Palindrome number." },
    { id: 10, question: "Write a PHP program to display Fibonacci Series." },
    { id: 11, question: "Write a PHP program to create a simple LogIn and Logout using sessions." },
];

export default function MiniProject() {
    const loadCheckedState = () => {
        const storedState = localStorage.getItem('miniProjectCheckedState');
        return storedState ? JSON.parse(storedState) : {};
    };

    const [checkedState, setCheckedState] = useState(loadCheckedState);

    const saveCheckedState = () => {
        localStorage.setItem('miniProjectCheckedState', JSON.stringify(checkedState));
    };

    const handleCheckboxClick = (id) => {
        setCheckedState((prevState) => {
            const newState = { ...prevState, [id]: !prevState[id] };
            return newState;
        });
    };

    useEffect(() => {
        saveCheckedState();
    }, [checkedState]);

    return (
        <section id='miniProject' className="text-gray-600 body-font">
            <div className="container px-5 py-24 mx-auto">
                <div className="flex flex-col text-center w-full mb-20">
                    <h1 className="sm:text-3xl text-2xl font-medium title-font mb-4 text-red-600">PHP</h1>
                    <p className="lg:w-2/3 mx-auto leading-relaxed text-base">PHP Implementation</p>
                </div>
                <div className="flex flex-wrap -m-2">
                    {quests.map((question) => (
                        <div key={question.id} className="p-2 lg:w-1/3 md:w-1/2 w-full">
                            <div className={`h-full flex items-center border-red-600 border-2 bg-gray-100 p-4 rounded-lg ${checkedState[question.id] ? 'bg-green-100' : ''}`}>

                                <div className="flex-grow">
                                    <div className='flex gap-2 items-center'>
                                        <h2 className="text-gray-900 title-font font-medium">Question {question.id}</h2>
                                        <input
                                            type="checkbox"
                                            checked={checkedState[question.id]}
                                            onChange={() => handleCheckboxClick(question.id)}
                                            className="mr-2"
                                        />
                                    </div>
                                    <p className="text-gray-800">{question.question}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

{/* <Link
                                        activeClass="active"
                                        to="about"
                                        spy={true}
                                        smooth={true}
                                        offset={-130} // Adjust the offset as needed
                                        duration={500} // Adjust the duration of the scroll animation
                                    >
                                        About

                                    </Link> */}